import { CircleMarker, Tooltip, Popup } from "react-leaflet";
import { useState, useEffect } from "react";
import Button from '@mui/material/Button';
import Moment from 'react-moment';
import authHeader from "../../services/auth-header";

import { useTranslation } from "react-i18next";

const api = require("../../api/names.js");


function DetectorMarker(props){

  const { t } = useTranslation("common");

  const [color, setColor] = useState(props.color);
  const [fillColor, setFillColor] = useState(props.color);
  const [radius, setRadius] = useState(props.radius);
  const [permaTooltip, setPermaTooltip] = useState(true);

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [item, setItem] = useState([]);

  useEffect(() => {
    myfun(props.markDetectors, props.address);
    const interval = setInterval(() => {
      myfun(props.markDetectors, props.address);
    }, 5000);
    return () => {
      clearInterval(interval);
    };
  }, [props.markDetectors, props.address]);

  function myfun(detectors, addr) {
    var url = api.baseUrl+'/detectorsCurrentValues/ByAddress/';
    url += addr;
    //console.log(url);

    fetch(url, {
  method: 'get',
  headers: authHeader()
  })
    .then(res => res.json())
    .then(
      (result) => {
        if(result[0].isBusy === 0)
        {
          setColor("green");
          setFillColor("green");
        }
        else if(result[0].isBusy === 1)
        {
          setColor("red");
          setFillColor("red");
        }

        if (detectors.includes(addr))
        {
          setPermaTooltip(true);
        }
        else
        {
          setPermaTooltip(false);
        }

        if (detectors.includes(addr))
        {
          setColor("#B300FF");
        }
        else if(result[0].type === 1)
        {
          setColor("#1D94E6");
        }
        else if(result[0].type === 2)
        {
          setColor("#2BA70A");
        }
        setIsLoaded(true);
        setItem(result[0]);
        //console.log(result[0]);
      },
      (error) => {
        setIsLoaded(true);
        setError(error);
      }
    )
    setRadius(5);
  }

  if (error) {
    return <div>{t('detectord.error')}{error.message}</div>;
   } else if (!isLoaded) {
    return <div>{t('detectord.loading')}</div>;
   } else {
  return (

      <CircleMarker

        center={[props.lat, props.lon]}
        pathOptions={{ color: color, opacity: 0.8, fillColor: fillColor, fillOpacity: 0.6 }}
        radius={radius}
      >
      {permaTooltip &&
      <Tooltip  permanent>{
        <div>
        {props.positionOnParking} : {item.address}
        </div>
      }</Tooltip>}
      {!permaTooltip &&
        <Tooltip>{
          <div>
            {props.positionOnParking} : {item.address}
          </div>
        }</Tooltip>}
      <Popup>{
        <div>
          {t('marker.address')}{props.positionOnParking} : {item.address} <br />
          {t('marker.isbusy')}{item.isBusy} <br />
          {t('marker.frametime')}<Moment format="HH:mm:ss - DD/MM/YYYY" unix>{item.timestamp / 1000}</Moment><br />
          {t('marker.enter')}<Moment format="HH:mm:ss - DD/MM/YYYY" unix>{item.entryTimestamp / 1000}</Moment><br />
          {t('marker.leave')}<Moment format="HH:mm:ss - DD/MM/YYYY" unix>{item.exitTimestamp / 1000}</Moment><br />
          <Button href={'/detectorDetails/' + props.parkingID + '/' + item.address} variant="outlined" >{t('detectorsbp.his')}</Button>
        </div>
      }</Popup>
      </CircleMarker>

  );
  }
};

export default DetectorMarker;
